import { jsx as n } from "react/jsx-runtime";
import { createContext as o, useContext as r } from "react";
const t = o(null);
function l(e) {
  return /* @__PURE__ */ n(t.Provider, { value: e.value, children: e.children });
}
function x() {
  const e = r(t);
  if (!e)
    throw new Error("useTableContext must be used within a TableContextProvider");
  return e;
}
export {
  l as TableContextProvider,
  x as useTableContext
};
